<template>
    <div class="bg-white rounded-lg overflow-hidden shadow group border">
        <LoadContainer class="aspect-square" />
        <div class="p-5 border-t text-slate-400">
            <div class="flex flex-row justify-between items-center gap-1.5">
                <LoadItem class="h-4 w-full rounded" />-
                <LoadItem class="h-4 w-full rounded animation-delay-200" />
            </div>

            <LoadContainer class="h-4 rounded-none mt-2" />
            <LoadContainer class="h-4 rounded-none mt-1 animation-delay-200" />

            <LoadItemText class="mt-6 text-sm">
                Loading Price
            </LoadItemText>
            <LoadItem class="h-6 w-16 rounded mt-1 bg-slate-200" />
        </div>
    </div>
</template>

<script setup lang="ts">
import LoadContainer from './LoadContainer.vue';
import LoadItemText from './LoadItemText.vue';
import LoadItem from './LoadItem.vue';
</script>